import T from "../../theme";
import { Icon } from "../ui/Icon";
import { Avatar } from "../ui/Avatar";
import logoEscuro from "../../assets/logo_escuro.svg";
import logoBranco from "../../assets/logo_branco.svg";

export const TopBar = ({ user, dark, onToggleDark, onOpenDrawer, onEditProfile, isAdmin, activeCondo, condoCount }) => (
  <div style={{
    position: "sticky", top: 0, zIndex: 100,
    height: 56, flexShrink: 0,
    background: T.sidebar, borderBottom: `1px solid ${T.border}`,
    display: "flex", alignItems: "center",
    padding: "0 16px", gap: 12,
  }}>

    {/* Logo + condo name */}
    <div style={{ flex: 1, display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
      <img
        src={dark ? logoEscuro : logoBranco}
        alt="VillaGest"
        style={{ height: 24, width: "auto", flexShrink: 0 }}
      />
      {activeCondo && condoCount > 1 && (
        <span style={{
          fontSize: 11, fontWeight: 600, color: T.textMuted,
          overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
          maxWidth: 140,
        }}>
          {activeCondo.name}
        </span>
      )}
    </div>

    {/* Dark toggle */}
    <button
      onClick={onToggleDark}
      style={{ background: "none", border: "none", cursor: "pointer",
               color: T.textMuted, padding: 8, display: "flex", borderRadius: 8 }}>
      <Icon name={dark ? "sun" : "moon"} size={18} color={T.textMuted} />
    </button>

    {/* Avatar (clickable for non-admin users) */}
    <div
      onClick={!isAdmin ? onEditProfile : undefined}
      style={{ cursor: isAdmin ? "default" : "pointer", flexShrink: 0 }}>
      <Avatar user={user} size={32} />
    </div>

    {/* Hamburger */}
    <button
      onClick={onOpenDrawer}
      style={{ background: "none", border: "none", cursor: "pointer",
               color: T.textMuted, padding: 8, display: "flex", borderRadius: 8,
               flexShrink: 0 }}>
      <Icon name="menu" size={22} color={T.text} />
    </button>
  </div>
);
